import { mapState, mapActions, mapMutations } from "vuex";
import { _message } from "@/helpers/_message";
export default {
	props: ["stt", "nganhId", "length"],
	data() {
		return {
			tohops: [],
			nguyenvong: {},
			isdeleted: false,
		};
	},
	computed: {
		...mapState({
			nganhs: (state) => state.nganh.nganhs,
			nguyenvongs: (state) => state.nguyenvong.nguyenvongs,
			cosoes: (state) => state.coso.cosoes,
			dotdangky: (state) => state.dotdangky.dotdangky,
		}),
	},
	methods: {
		...mapActions({
			getTopHopsByNganhId: "tohop/getTopHopsByNganhId",
			layThongTinNguyenVong: "nguyenvong/layThongTinNguyenVong",
			updateNganhId: "nguyenvong/updateNganhId",
			updateToHopId: "nguyenvong/updateToHopId",
			updateCoSoId: "nguyenvong/updateCoSoId",
			xoaMonHoc: "tohop/xoaMonHoc",
			themMonHoc: "tohop/themMonHoc",
			updateTenToHop: "nguyenvong/updateTenToHop",
		}),
		...mapMutations({
			xoaNguyenVong: "nguyenvong/xoaNguyenVong",
			updateIsLoadDelete: "tohop/updateIsLoadDelete",
		}),
		async getNganhTopHop(id) {
			let nguyenvong = await this.nguyenvongs.findIndex(
				(item) => item.nganhId === id && item.nganhId != "",
			);
			if (nguyenvong != this.stt && nguyenvong >= 0) {
				_message.messageTrungNganh();
				this.nguyenvong = {
					coSoId: nguyenvong.coSoId
				};
				return;
			}
			if (id) {
				await this.updateNganhId({
					index: this.stt,
					id: id,
				});
				await this.getTopHopsByNganhId(id)
					.then((response) => {
						this.tohops = [...response];
					})
					.catch((err) => console.error(err));
			}
		},
		async deleteNguyenVong() {
			await this.xoaMonHoc(this.nguyenvong.toHopId);
			await this.xoaNguyenVong(this.stt);
			await this.layThongTinNguyenVong(this.stt).then((data) => {
				this.nguyenvong = { ...data };
			});
		},
		async khaiBaoDiem(id) {
			await this.updateIsLoadDelete(false);
			await this.updateToHopId({ index: this.stt, id: id });
		},
		async updateMonHoc(newId, oldId) {
			if (this.dotdangky && this.dotdangky.loaiDot != 'CAOHOC') {
				if (newId) {
					await this.themMonHoc(newId)
						.then((response) => {
							if (response.status === 200)
								this.updateTenToHop({
									toHopId: response.data.toHopId,
									tenToHop: response.data.tenToHop,
									maToHop: response.data.maToHop
								});
						})
						.catch((err) => console.error(err.message));
				}
				if (oldId) {
					await this.xoaMonHoc(oldId);
				}
			}

		},
	},
	watch: {
		"nguyenvong.toHopId"(newValue, oldValue) {
			this.updateMonHoc(newValue, oldValue);
		},
	},
};
